import { Button, Carousel, Pagination } from 'antd'
import React from 'react'

import useLoadMore from '@hooks/useLoadMore'
import Flex from '@ui-pc/Flex'
import Icon from '@ui-pc/Icon'
import Image from '@ui-pc/Image'
import Rate from '@ui-pc/RateStars'
import Switch from '@ui-pc/Switch'
import Text from '@ui-pc/Text'
import { isMobileProject } from '@utils/index'
import { Knife, Type } from '@utils/tool'
import Slot from '@utils/tool/fc/slot'
import { insideLoopsOfHook } from '@utils/tool/khook'

import { ctx } from '../../../utils'
import { Props } from '../types'
import Avatar from './Avatar'
import Liked from './Liked'
import { VideoBox } from './VideoBox'

type Id = 'avatar' | 'rate' | 'content' | 'helpful' | 'imgs' | 'videos'

const Video = (props) => {
  const { src } = props

  const videoRef = React.useRef<HTMLVideoElement>()

  const onClick = () => {
    const video: any = videoRef.current
    if (video.requestFullscreen) {
      // 最新标准
      video.requestFullscreen()
      video.play()
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen()
      video.play?.()
    }
  }

  // if (!isMobileProject) {
  //   return (
  //     <li className="comment-media">
  //       <video ref={videoRef} controls={false} className="img" src={src} />
  //     </li>
  //   )
  // }

  return (
    <li className="comment-media">
      <VideoBox readonly>
        <video
          // onClick={onClick}
          controls={false}
          ref={videoRef}
          className="img"
          src={src}
        />
      </VideoBox>
    </li>
  )
}

export const Content = (props: Props) => {
  const { children } = props

  const [state] = ctx.useState()

  const ref = ctx.useRef()

  const { reviews, reviewCount } = state

  const { data, loadMore, isNoMore } = useLoadMore({
    data: reviews,
    size: ref.current.pageSizeNum,
    setupNum: ref.current.pageSizeNum
  })

  //todo m端数据
  const dupReviews = isMobileProject ? data : reviews

  const ViewPhotosDetail = ref.main.ViewPhotosDetail

  const InfiniteScroll = ref.main.InfiniteScroll

  return (
    <Switch either={!Type.isEmpty(reviews)}>
      <Flex className="rate-content">
        {/* <Gap size={32} /> */}
        {insideLoopsOfHook(dupReviews).map((data) => {
          const avatar = (
            <>
              <Avatar
                className="avatar"
                colorNum={data.avatarColorNum}
                content={data.username}
              />
              <Flex className="info" span="auto" direction="column">
                <span className="username" title={data.username}>
                  {data.username}
                </span>
                <span className="verified-buyer">{'Verified Buyer'}</span>
              </Flex>
            </>
          )

          const rate = (
            <>
              <Rate className="comment-rate" value={data.score} />
              <span className="date">{data.date}</span>
            </>
          )

          const { saleOptions } = data.skuInfo || {}

          const content = (
            <Slot id="content">
              <Text className="comment-content-title top12">
                <span dangerouslySetInnerHTML={{ __html: data.title }}>
                  {/* {data.title} */}
                </span>
              </Text>
              <p className="comment-content-sku">
                {saleOptions?.map((data) => {
                  return (
                    <>
                      <Text type="secondary">{data}</Text>
                      <Text className="separator" type="secondary">
                        /
                      </Text>
                    </>
                  )
                })}
              </p>
              <p
                className="comment-content"
                dangerouslySetInnerHTML={{ __html: data.content }}></p>
            </Slot>
          )

          const refs = React.useRef<any>({})

          const imgs = data.images?.map((resource, index) => {
            return (
              <li
                onClick={() => {
                  refs.current.useShow(index)
                }}
                className="comment-media"
                key={resource}>
                <Image
                  alt={resource}
                  preview={false}
                  className="img"
                  src={resource}
                />
              </li>
            )
          })

          const videos = data.videos?.map((resource) => {
            return <Video src={resource} key={resource} />
          })

          const medium = data.medium?.map((source, index) => {
            return (
              <div
                onClick={() => {
                  refs.current.useShow(index)
                }}>
                <Switch either={source.type === 2}>
                  <Video src={source.src} key={source.src} />
                  <li className="comment-media" key={source.src}>
                    <Image
                      alt={source.src}
                      preview={false}
                      className="img"
                      src={source.src}
                    />
                  </li>
                </Switch>
              </div>
            )
          })

          const helpful = (
            <Slot id="helpful">
              <Liked
                liking={data.isLike}
                onClick={(isLike) => {
                  return ref.current.onLike({
                    reviewId: data.reviewId,
                    isLike: +isLike
                  })
                }}>
                {data.likes}
              </Liked>
            </Slot>
          )

          const reply = (
            <Switch either={!Type.isEmpty(data.reviewReplies)}>
              <Flex className="reply">
                <Flex className="reply-box" alignItems="center">
                  <span className="triangle-up" />
                  {/* data.reviewReplies */}
                  {data.reviewReplies?.map((rep) => {
                    return (
                      <div className="reply-content">
                        <Icon src={rep.avatar || '/'} />
                        <span>{rep.content}</span>
                      </div>
                    )
                  })}
                </Flex>
              </Flex>
            </Switch>
          )

          if (children) {
            return (
              <>
                <ViewPhotosDetail
                  list={[data]}
                  refs={refs}
                  photos={data.medium}
                />
                <props.children
                  helpful={helpful}
                  medium={medium}
                  imgs={imgs}
                  videos={videos}
                  rate={rate}
                  avatar={avatar}
                  content={content}
                  reply={reply}
                />
              </>
            )
          }

          return (
            <Flex className="content-box" warp={false}>
              <ViewPhotosDetail
                list={[data]}
                refs={refs}
                photos={data.medium}
              />
              <Flex
                span="auto"
                className="box-left"
                alignItems="center"
                warp={false}>
                {avatar}
              </Flex>
              <Flex className="box-right">
                <Flex className="comment" direction="column">
                  <Flex justify="space-between">{rate}</Flex>
                  {content}
                  {/* <div>{imgs}</div>
                  <div>{videos}</div> */}
                  <Flex>{medium}</Flex>
                </Flex>
                <Flex className="share" alignItems="center">
                  {/* <span
                  onClick={() => {
                    ref.current.onShare()
                  }}>
                  share
                </span> */}
                  {helpful}
                </Flex>
                <Switch either={!Type.isEmpty(data.reviewReplies)}>
                  <Flex className="reply">
                    <Flex className="reply-box" alignItems="center">
                      <span className="triangle-up" />
                      {data.reviewReplies?.map((rep) => {
                        return (
                          <div className="reply-content">
                            <Icon src={rep.avatar || '/'} />
                            <span>{rep.content}</span>
                          </div>
                        )
                      })}
                    </Flex>
                  </Flex>
                </Switch>
              </Flex>
            </Flex>
          )
        })}

        <Switch either={!!isMobileProject}>
          <InfiniteScroll loadMore={async () => loadMore()} hasMore={!isNoMore}>
            {''}
          </InfiniteScroll>
          <Pagination
            className="pagination"
            hideOnSinglePage
            current={ref.reviewsQuery?.page}
            onChange={(page, pageSize) => {
              ref.current.onPaginationChange(page, pageSize)
            }}
            total={Type.number(reviewCount)}
            pageSize={ref.current.pageSizeNum}
          />
        </Switch>
      </Flex>
      <Flex justify="center">
        <Text
          width={600}
          textAlign="center"
          size={18}
          gap={[16, 0]}
          cursor
          onClick={ref.current.onWrite}>
          No reviews for this rating
        </Text>
      </Flex>
    </Switch>
  )
}

const Card = (props: Props) => {
  const { children } = props

  const [state, setState] = ctx.useState()

  //const ref = ctx.useRef()

  const { reviewCard } = state
  const mobileSetting = isMobileProject
    ? { arrows: false, slidesToShow: 1.3, slidesToScroll: 1 }
    : {}
  return (
    <div className="content-card" style={{ width: '100%' }}>
      <Carousel
        {...{
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3.3,
          slidesToScroll: 3,
          arrows: true,
          className: 'widget-review-slider grey-button',
          nextArrow: (
            <Button
              aria-label="@hernest.com"
              className="slider-button slider-next"
              icon={<Icon customSrc="icon-m_ic_jiantou" />}
            />
          ),
          prevArrow: (
            <Button
              aria-label="@hernest.com"
              className="slider-button slider-pre"
              icon={
                <Icon
                  customSrc="icon-m_ic_jiantou"
                  style={{ transform: 'rotateY(180deg)' }}
                />
              }
            />
          ),
          ...mobileSetting
        }}>
        {reviewCard?.slice(0, 6).map((data) => {
          const rate = (
            <>
              <p>
                <span className="username">
                  {data.username} {'   '}
                </span>
                <Text type="secondary" className="date">
                  {data.date}
                </Text>
              </p>
              <Flex span={'auto'} className="comment-rate-area">
                <Rate className="comment-rate" value={data.score} />
              </Flex>
            </>
          )

          const content = (
            <Slot id="content">
              <Flex
                className="comment-content-title-head"
                paddingTop={16}
                rowGap={8}
                direction="column">
                <span
                  className={`comment-content-title ${
                    isMobileProject && 'comment-content-card-twoline'
                  }`}
                  dangerouslySetInnerHTML={{ __html: data.title }}>
                  {/* {data.title}{' '} */}
                </span>
                <p
                  dangerouslySetInnerHTML={{ __html: data.content }}
                  className={`comment-content-card ${
                    data.medium.length !== 0 && 'comment-content-card-twoline'
                  }`}>
                  {/* {data.content} */}
                </p>
              </Flex>
            </Slot>
          )

          return (
            <Flex
              onClick={() => setState({ isExpand: !state.isExpand })}
              cursor
              className="content-box-area"
              warp={false}
              paddingRight={24}>
              <Flex className="content-box-card" padding={[16]}>
                <Flex className="comment" direction="column">
                  <Flex
                    justify="space-between"
                    alignItems="center"
                    warp={false}>
                    {rate}
                  </Flex>
                  {content}
                  <div style={{ width: '100%' }}>
                    <Carousel
                      {...{
                        dots: false,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        ...(isMobileProject
                          ? { slidesToShow: 3.1, slidesToScroll: 3.1 }
                          : {})
                      }}>
                      {data.medium.map((source) => {
                        return (
                          <Switch either={source.type === 1}>
                            <div
                              className="comment-media-card"
                              key={source.src}>
                              <Image
                                preview={false}
                                className="img"
                                alt={source.src}
                                src={source.src}
                              />
                            </div>
                            <div className="comment-media-card">
                              <Video src={source.src} key={source.src} />
                            </div>
                          </Switch>
                        )
                      })}
                    </Carousel>
                  </div>
                </Flex>
              </Flex>
            </Flex>
          )
        })}
      </Carousel>
    </div>
  )
}

Content.Card = Card
